import { StudyAssessmentMeasurement, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { studyAssessmentMeasurementClient } from './StudyAssessmentMeasurementClient';

const factory = createStudyEntityHookFactory<StudyAssessmentMeasurement>(StudyEntityType.StudyAssessmentMeasurement);

export const useStudyAssessmentMeasurements = factory.list(studyAssessmentMeasurementClient.list);
export const useStudyAssessmentMeasurementsPaginated = factory.listPaginated(
    studyAssessmentMeasurementClient.listPaginated
);
